import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';
import ImageIcon from 'components/ImageIcon';
import Button from 'components/Button';
import Media from 'components/Media';

import cn from 'classnames';
import css from './LinkListBlock.module.scss';

import { THEMES, getThemeClassNames } from 'constants/themes';

class LinkListBlock extends React.Component {
    static propTypes = {
        heading: PropTypes.string.isRequired,
        text: PropTypes.string,
        links: PropTypes.arrayOf(PropTypes.shape({
            href: PropTypes.string,
            language: PropTypes.string,
            target: PropTypes.string,
            text: PropTypes.string,
            title: PropTypes.string
        })),
        icon: PropTypes.string,
        iconNew: PropTypes.shape(ImageIcon.propTypes),
        theme: PropTypes.oneOf(Object.values(THEMES)),
        size: PropTypes.number,
        backgroundVideo: Media.propTypes.video,
        backgroundImage: Media.propTypes.image,
        blockId: PropTypes.number,
    };

    static defaultProps = {
        theme: 0
    }

    constructor(props){
        super();
        let theme = props.theme;

        // override theme for video block
        if(props.backgroundVideo && props.backgroundVideo.length > 0){
            theme = THEMES.darkgray;
        }

        this.state = {
            theme: theme
        };
    }

    _handlePlayClick = () => this.setState({ playing: true })

    render() {
        const {
            heading,
            text,
            links,
            icon,
            iconNew,
            size,
            backgroundVideo,
            backgroundImage,
            blockId,
        } = this.props;

        const { theme } = this.state;

        const classNames = cn(css.block, {
            ...getThemeClassNames(css, theme),
            [css.bg]: theme === THEMES.illustration,
            [css.tall]: size,
            [css.video]: backgroundVideo && backgroundVideo.length > 0
        });

        return (
            <div
                className={classNames}
                data-block={blockId}
            >
                <div className={css['block-content']}>
                    <div className={css['list-content']}>
                        {iconNew ? (
                            <div className={css.icon}>
                                <ImageIcon {...iconNew} />
                            </div>
                        ) : 
                            (icon ? (
                                <div className={css.icon}><Icon icon={icon} /></div>
                            ) : null)
                        }
                        {heading && <h2 className={css.heading}>{heading}</h2>}
                        {text && <p className={css.text}>{text}</p>}
                        {links && (
                            <ul className={css.links}>
                                {links.map((link, index) => (
                                    <li key={index}>
                                        <Button secondary {...link} {...{light : theme === THEMES.darkgray}}>
                                            {link.text}
                                        </Button>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    {backgroundVideo && backgroundVideo.length > 0 && (
                        <div className={css.videoplayer}>
                            <Media video={backgroundVideo} image={backgroundImage} />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default LinkListBlock;


// WEBPACK FOOTER //
// ./src/components/LinkListBlock/LinkListBlock.jsx